<template>
  <div class="d-flex align-items-center" style="font-size: 2.6rem; cursor: pointer;">
    <span v-if="start === true" class="mr-2" style="font-size: 15px;">Tối đa {{ maxTime }} phút</span>
    <span v-if="start === true" class="mr-2" style="font-size: 30px;">{{ formatTime(second) }}</span>
    <b-icon title="Start record" v-if="start === false" icon="mic-fill" @click="recordForMaxSeconds()" class="border border-info rounded-circle p-2" variant="info"></b-icon>
    <b-icon title="Stop record" v-if="start === true" icon="pause-fill" @click="stop()" class="border border-info bg-danger rounded-circle p-2" animation="" font-scale="" variant="light"></b-icon>

    <!-- <b-icon icon="stop-fill" @click="stop()" class="border border-info rounded-circle p-2" variant="info"></b-icon> -->
    <!-- <audio v-if="src !== null" :src="src" controls="controls" style=""></audio> -->
  </div>
</template>
<script>
import RecordRTC from 'recordrtc';

export default {
  props: {
    index: {
        type: Number,
        default: 0
    },
    maxTime: {
        type: Number,
        default: 1
    }
  },
  data() {
    return {
      recorder: null,
      chunks: [],
      device: null,
      blobObj: null,
      start: false,
      timeout: null,
      src: null,
      interval: null,
      second: 0,
      stream: null,
    };
  },

  created() {
   // this.device = navigator.mediaDevices.getUserMedia({ audio: true });
  },
  methods: {

    async recordAudio() {

        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            alert('Thiết bị không hỗ trợ ghi âm.');
            return;
        }

        try {

            // this.device = navigator.mediaDevices.getUserMedia({ audio: true });
            // this.device.then((stream) => {
            //     this.recorder = new MediaRecorder(stream);
            //     this.recorder.ondataavailable = (e) => {
            //     this.chunks.push(e.data);
            //     if (this.recorder.state === "inactive") {
            //         let blob = new Blob(this.chunks, { type: "audio/mp3" });
            //     // let src = (window.URL || window.webkitURL).createObjectURL( blob );
            //     // let file = new File([blob], 'record.mp3');
            //         // save to blobObj
            //         this.blobObj = blob;
            //         this.chunks = [];

            //     // console.log(file);

            //     // this.src = src;
            //         // emit to parent
            //         this.$emit("send-audio", this.blobObj, this.index);
            //         this.blobObj = null;
            //     }
            //     };
            //     // start record
            //     this.recorder.start();
            //     this.start = true;
            //     this.$emit("start-record", this.start, this.index);
            //     this.countTime();

            // });

            this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            this.recorder = new RecordRTC(this.stream, {
            type: 'audio',
            mimeType: 'audio/wav',
            recorderType: RecordRTC.StereoAudioRecorder,
            numberOfAudioChannels: 1,
            desiredSampRate: 16000,
            });
            this.start = true;
            this.recorder.startRecording();

            this.$emit("start-record", this.start, this.index);

            this.countTime();

        } catch (err) {
            console.error('Lỗi khi khởi tạo thu âm:', err);
            alert('Không thể truy cập microphone. Vui lòng kiểm tra quyền và thử lại.');
        }
    },
    async recordForMaxSeconds() {
        this.recordAudio();
    //   this.timeout =  setTimeout(() => {
    //         this.stop();
    //     }, 10000);
     //   this.countTime();
    },
    // stop() {
    //   // stop record

    //   //clearTimeout(this.interval);
    //   clearInterval(this.interval);
    //   this.recorder.stop();
    //   this.start = false;
    //   this.second = 0;
    //   this.$emit("start-record", this.start, this.index);

    // },

    stop() {
        if (this.recorder) {
            this.recorder.stopRecording(() => {
                const blob = this.recorder.getBlob();
                this.$emit("send-audio", blob, this.index);

                // cleanup
                this.recorder.destroy();
                this.recorder = null;

                if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop());
                this.stream = null;
                }
            });
        }

        this.start = false;
        clearInterval(this.interval);
        this.second = 0;
        this.$emit("start-record", this.start, this.index);
    },


    // stop() {
    //     if (this.recorder) {
    //         this.recorder.stop();

    //         // this.recorder.exportWAV(blob => {
    //         // this.$emit("send-audio", blob, this.index);
    //         // });
    //         this.recorder.exportWAV(blob => {
    //             const reader = new FileReader();
    //             reader.onload = async () => {
    //                 const wavData = reader.result;
    //                 const mp3Blob = this.encodeWAVtoMP3(wavData);
    //                 this.$emit("send-audio", mp3Blob, this.index, blob);
    //             };
    //             reader.readAsArrayBuffer(blob);
    //         });
    //     }

    //     if (this.stream) {
    //         this.stream.getTracks().forEach(track => track.stop());
    //     }

    //     clearInterval(this.interval);
    //     this.second = 0;
    //     this.start = false;
    //     this.$emit("start-record", this.start, this.index);
    // },

    encodeWAVtoMP3(arrayBuffer) {
        const wav = lamejs.WavHeader.readHeader(new DataView(arrayBuffer));
        const samples = new Int16Array(arrayBuffer, wav.dataOffset, wav.dataLen / 2);

        const mp3Encoder = new lamejs.Mp3Encoder(1, wav.sampleRate, 128);
        const mp3Data = [];

        const sampleBlockSize = 1152;
        for (let i = 0; i < samples.length; i += sampleBlockSize) {
            const sampleChunk = samples.subarray(i, i + sampleBlockSize);
            const mp3buf = mp3Encoder.encodeBuffer(sampleChunk);
            if (mp3buf.length > 0) mp3Data.push(mp3buf);
        }

        const mp3buf = mp3Encoder.flush();
        if (mp3buf.length > 0) mp3Data.push(mp3buf);

        return new Blob(mp3Data, { type: "audio/mp3" });
    },


    countTime() {
        this.interval = setInterval(() => {
            this.second++;
            if (this.second === (this.maxTime * 60)) {
                this.stop();
                clearInterval(this.interval);
                this.$root.toast(
                    "Notification",
                    "success",
                    "Hết thời gian ghi âm."
                );
            }
        }, 1000);
    },
    formatTime(d) {
            d = Number(d);
            let h = Math.floor(d / 3600);
            let m = Math.floor((d % 3600) / 60);
            let s = Math.floor((d % 3600) % 60);
            let hDisplay = h >= 10 ? h : "0" + h;
            let mDisplay = m >= 10 ? m : "0" + m;
            let sDisplay = s >= 10 ? s : "0" + s;
            return mDisplay + ':' + sDisplay;
            //return (this.timeOut = mDisplay + ":" + sDisplay);
        },
  },
};
</script>
